import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  section: {
    padding: theme.spacing(4, 0),
  },
  title: {
    marginBottom: theme.spacing(4),
  },
  cttExpressPointButtonContained: {
    border: '1px solid #C9E16F',
    backgroundColor: '#B4D246',
    color: 'white',
    '&:hover': {
      border: '1px solid #C9E16F',
      backgroundColor: '#B4D246',
      color: 'white',
      boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.2)',
    },
  },
  cttExpressPointButtonOutlined: {
    border: '1px solid #C9E16F',
    color: '#B4D246',
    backgroundColor: 'white',
    '&:hover': {
      border: '1px solid #B4D246',
      color: '#B5D246',
      backgroundColor: 'white',
      boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.2)',
    },
  },
}))

export default useStyles
